import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// theme.css 里 DeeVid 的自定义 token，告诉 tailwind-merge 它们和同类默认值互斥，
// 否则 cn("shadow-xs", "shadow-card") 两个都留下，谁生效看 CSS 顺序
const twMerge = extendTailwindMerge({
	extend: {
		theme: {
			shadow: ["card", "card-lg", "popover", "cta", "composer"],
			radius: ["20", "28", "48"],
			tracking: ["body", "heading"],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
